// *********** HOME COLABORADOR ***************************************
// *** pc_home.jsx ***********
// *** autor: W de Paula / MVinfo
// *** data: 16/10/24 | 12h50
// *** data: 25/10/25 | 19h55 - acrescentada variáveis de validações de cpf/cnpj validados e se conta prestador está bloqueada ou não.
// ***********************************************************





import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import Swal from "sweetalert2";
// import apiaxios from "../../../../Services/apiaxios.js";
// import handleApiError from '../../../../Services/apiErrorHandler.js';
// import { encrypt, decrypt } from "../../../../Services/cryptoUtils.js";
import { pc_getUserData } from "../../Services/pc_userutils.js";
import { useCarregaDados } from "../../Hooks/pc_usecarregadados.jsx";
import { AutoLogout } from "../../../../Services/autologout.js";
import { Container, Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente

import PCMenu from "../../Components/Menu/pc_menu.jsx";
import PCMenuConfig from "../../Components/Menu/pc_menuconfig.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './pc_home.css';

function PCHome() {
    const tokenASW = localStorage.getItem("tokenasw");
    useEffect(() => {
        const tokenLG = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = pc_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa);
    // const [tipoAtendimento] = useState(initialUserData.tipoAtendimento); // Usar setIdUsuario para atualizar o id_usuario
    // const [agendaFechada, setAgendaFechada] = useState(initialUserData.agenda_fechada);  // 0 = Aberta, 1 = Fechada
    // const [tipoAgenda, setTipoAgenda] = useState(initialUserData.tipoAgenda); // 0 = Global, 1 = Individual
    // const [qtServicos, setQTServicos] = useState(0); // total de serviços cadastrados
    // const [qtServicosAvulsos, setQTServicosAvulsos] = useState(0); // total de serviços cadastrados disponíveis pra agendamento avulso
    // const [lock, setLock] = useState(0);  // 0 = prestador liberado, 1 = prestador bloqueado por fim de contrato
    const navigate = useNavigate();

    // novas variáveis para validar as credenciais do contrato também no colaborador 25/10/25w
    const [diasVencimentoContrato, setdiasVencimentoContrato] = useState(initialUserData.dias_FimContrato);  // receber a quantidade de dias que faltam pra encerrar o contrato 6/12/24w
    const [validado, setvalidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    // const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado);
    const [lock, setLock] = useState(initialUserData.bloqueio);  // 0 = prestador liberado, 1 = prestador bloqueado por fim de contrato // linha acima

    // console.log('const validado ', validado);

    useEffect(() => {
        // console.log('executarverificacoes');
        const executarVerificacoes = async () => {
            // console.log('executarverificacoes');
            if (userId !== 0 && userId !== undefined) {
                // Verifica se o email está validado
                // const emailValidadoOk = await VerificaEmailValidado(userId, emailValidado);
                // if (!emailValidadoOk) return;  // Se não está validado, não continua
    
                // // Verifica se a empresa está cadastrada
                // const empresaCadastradaOk = await VerificaSeEmpresaCadastrada(userId, indEmpresa);
                // if (!empresaCadastradaOk) return;  // Se não está cadastrada, não continua
    
                // Verifica se a empresa está bloqueada
                const empresaDesbloqueadaOk = await VerificaSeEmpresaBloqueada(lock);
                if (!empresaDesbloqueadaOk) return;  // Se está bloqueada, não continua
    
                // // Verifica se o CPF/CNPJ está validado
                // const cpfCnpjValidadoOk = await VerificaSeCpfCnpjValidado(validado);
                // if (!cpfCnpjValidadoOk) return;  // Se não está validado, não continua

                // Verifica se está vencendo pra renovar contrato ou contratar novo
                const faltaMenosCincoDiasOk = await VerificaDiasFaltaVencerContrato(diasVencimentoContrato);
                if (!faltaMenosCincoDiasOk) return;  // Se está bloqueada, não continua
                
            }
        };
    
        executarVerificacoes();
    // }, []);
    // }, [userId, indEmpresa, lock]);
    }, [indEmpresa, lock, validado]);
    // }, [userId, emailValidado, indEmpresa, lock, validado]);
    
    // // Função para verificar se o email está validado
    // const VerificaEmailValidado = async (userId, emailValidado) => {
    //     if (emailValidado === 0) {
    //         const result = await Swal.fire({
    //             title: 'Ativação da Conta',
    //             text: 'Para cadastrar sua empresa no AgendeX, você precisa validar seu email. Deseja validá-lo agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, validar!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    //         if (result.isConfirmed) {
    //             carregaDados(userId); // Função para carregar dados e validar email
    //             return false; // Para o fluxo até a validação ser concluída
    //         } else {
    //             AutoLogout();
    //             return false; // Impede continuação
    //         }
    //     }
    //     return true; // Email validado, pode continuar
    // };
    
    // // Função para verificar se a empresa está cadastrada
    // const VerificaSeEmpresaCadastrada = async (userId, indEmpresa) => {
    //     if (indEmpresa === 0 || indEmpresa === null || indEmpresa === undefined) {
    //         const result = await Swal.fire({
    //             title: 'Cadastro Incompleto',
    //             text: 'Para continuar, você precisa completar os dados do seu Negócio/Empresa. Deseja continuar o cadastro agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, cadastrar!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    
    //         if (result.isConfirmed) {
    //             if (userId) {
    //                 navigate('/app/prestador/perfil/cadastrarempresa', { 
    //                     state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/prestador/home/' } 
    //                 });
    //             } else {
    //                 console.error("userId não definido");
    //             }
    //             return false; // Para impedir continuação
    //         } else {
    //             AutoLogout();
    //             return false; // Para impedir continuação
    //         }
    //     }
    //     return true; // Empresa cadastrada, pode continuar
    // };
    
    // Função para verificar se a empresa está bloqueada
    const VerificaSeEmpresaBloqueada = async (lock) => {
        // console.log('verificaSeEmpresaBloqueada lock', lock);
        if (lock !== 0) {
            const result = await Swal.fire({
                title: 'Cadastro Bloqueado',
                text: 'Para desbloquear seu acesso, solicite que o dono do estabelecimento, entre em contato com o Suporte Agendex. Deseja fazer logout agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, fazer logout!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                localStorage.clear();
                navigate('/');
            } else {
                AutoLogout();
            }
            return false; // Empresa bloqueada, impede continuação
        }
        return true; // Empresa desbloqueada, pode continuar
    };
    
    // // Função para verificar se o CPF/CNPJ está validado
    // const VerificaSeCpfCnpjValidado = async (validado) => {
    //     // console.log('verificaSeCpfValidado validado ', validado);
    //     if (validado !== 1) {
    //         const result = await Swal.fire({
    //             title: 'Cadastro em Validação',
    //             text: 'Estamos agilizando a validação do cadastro do estabelecimento. Tente mais tarde ou solicite ao responsável pelo estabelecimento para entrar em contato com o suporte Agendex. Deseja fazer logout agora?',
    //             icon: 'question',
    //             showCancelButton: true,
    //             confirmButtonText: 'Sim, fazer logout!',
    //             cancelButtonText: 'Cancelar',
    //             allowOutsideClick: false,
    //             allowEscapeKey: false
    //         });
    //         if (result.isConfirmed) {
    //             localStorage.clear();
    //             navigate('/');
    //         } else {
    //             AutoLogout();
    //         }
    //         return false; // CPF/CNPJ não validado, impede continuação
    //     }
    //     return true; // CPF/CNPJ validado, pode continuar
    // };

    // Função para verificar quantos dias que faltam pra encerrar o contrato
    const VerificaDiasFaltaVencerContrato = async (dias) => {
        if (dias <= 5 && dias >=1 ) {
            const result = await Swal.fire({
                title: 'Contrato Finalizando',
                text: 'Faltam ' + dias + ' para o fim do contrato do estabelecimento onde você trabalha. Deseja fazer logof e avisar ao responsável pelo estabelecimento agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, fazer logout!',
                cancelButtonText: 'Agora não!',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                // localStorage.clear(); // substituída pelas linhas abaixo 30/12/24w
                localStorage.removeItem("tokenlg");
                localStorage.removeItem("tokenapw");
                localStorage.removeItem("tokenasw");

                navigate('/');
            } else {
                // AutoLogout();
                return true; // pode continuar
            }
            return false; // impede continuação
        }
        return true; // pode continuar
    };
    
    
    const { loading, setLoading, MySwal, carregaDados, carregaTotalServicos } = useCarregaDados();

    // useEffect(() => {
    //     if (userId) {
    //         carregaTotalServicos(userId, setQTServicos, setQTServicosAvulsos);
    //     }
    // }, [userId]);

    // const toggleAgendaStatus = async () => {
    //     const novoStatus = agendaFechada === 0 ? 1 : 0;
    //     setAgendaFechada(novoStatus);
    //     setLoading(true);
    //     try {
    //         // console.log(tokenASW);
    //         const response = await apiaxios.put('Usuario/AgendaFechadaWeb', {
    //             id_usuario: userId,
    //             // token: tokenASW,
    //             agenda_fechada: novoStatus
    //         }, {params: {id_usuario: userId, token: tokenASW}});
    
    //         if (response.status === 200 && response.data.retorno === 'OK') {
    //             // MySwal.fire('Status da Agenda', '"Status da Agenda" mudado com sucesso!', 'info');
    //             const mensagemStatus = novoStatus === 0 
    //                 ? '"Status da Agenda" mudado para "Aberta" com sucesso!' 
    //                 : '"Status da Agenda" mudado para "Fechada" com sucesso!';

    //             MySwal.fire('Status da Agenda', mensagemStatus, 'info');
                
    //             const encryptedToken = localStorage.getItem('tokenapw');
    //             const token = decrypt(encryptedToken);
    //             token.agenda_fechada = novoStatus;
    //             const updatedEncryptedToken = encrypt(token);
    //             localStorage.setItem('tokenapw', updatedEncryptedToken);
    //         } else {
    //             throw new Error(response.data.retorno || 'Falha ao carregar seus dados.');
    //         }
    //     } catch (error) {
    //         handleApiError(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    
    // // Função para alternar o tipo de agenda
    // const toggleTipoAgenda = async () => {
    //     Swal.fire('Tipo de Agenda', 'Opção indisponível na Web. Para modificar, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    // };

    // // Função para fazer agendamento avulso
    // const toggleAgendaAvulso = async () => {
    //     Swal.fire('Agendamento Avulso', 'Opção indisponível na Web. Para realizar um agendamento avulso, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    // };

    // // Função para alternar o tipo de atendimento
    // const toggleTipoAtendimento = async () => {
    //     Swal.fire('Tipo de Atendimento', 'Tome muito cuidado ao mudar esta opção que deve ser alterada no menu "Empresa". Nela você informa se trabalha sozinho(a) ou com funcionário(s).', 'info');
    // };

    // const toggleServicos = async () => {
    //     navigate('/app/prestador/empresa/servicos');
    // };
    
    // Função para navegar para Agendamentos Abertos
    const toggleAbertos = async () => {
        navigate('/app/colaborador/agendamentos/abertos', { 
            state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/colaborador/home' } 
        });
    };
    // Função para navegar para Agendamentos Concluidos
    const toggleConcluidos = async () => {
        navigate('/app/colaborador/agendamentos/concluidos', { 
            state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/colaborador/home' } 
        });
    };
    // Função para navegar para Agendamentos Excluidos
    const toggleExcluidos = async () => {
        navigate('/app/colaborador/agendamentos/excluidos', { 
            state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/colaborador/home' } 
        });
    };
    // Função para navegar para Agendamentos Pendentes
    const togglePendentes = async () => {
        navigate('/app/colaborador/agendamentos/pendentes', { 
            state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/colaborador/home' } 
        });
    };
    // <li>
    // <Link to="/app/colaborador/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
    //     <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-sm-inline menu-title">Abertos</span>
    // </Link>

    // Função para navegar para Perfil
    const togglePerfil = async () => {
        navigate('/app/colaborador/perfil', { 
            // state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/colaborador/home' } 
        });
    };



    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <PCMenu page='home' />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="text-center">
                                <h1>Home</h1>
                            </div>
                            <hr />

                            <PCMenuConfig id_usuario={userId} page="home"/>
                            <div className="container-fluid">
                                <Container>
                                    <h2 className="text-center">Meus Agendamentos</h2>
                                    {/* Botão "Agendamentos Abertos" */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                        <Button variant="primary" className="btn-lg"
                                            onClick={toggleAbertos}
                                        >
                                            <div><h1>Agendamentos Abertos</h1></div>
                                            {/* <div>{qtServicos} Cadastrados</div> */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    {/* Botão "Agendamentos Concluidos" */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                        <Button variant="success" className="btn-lg"
                                            onClick={toggleConcluidos}
                                        >
                                            <div><h1>Agendamentos Concluídos</h1></div>
                                            {/* <div>{qtServicos} Cadastrados</div> */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    {/* Botão "Agendamentos Excluídos" */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                        <Button variant="danger" className="btn-lg"
                                            onClick={toggleExcluidos}
                                        >
                                            <div><h1>Agendamentos Excluídos</h1></div>
                                            {/* <div>{qtServicos} Cadastrados</div> */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    {/* Botão "Agendamentos Pendentes" */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                        <Button variant="warning" className="btn-lg"
                                            onClick={togglePendentes}
                                        >
                                            <div><h1>Agendamentos Pendentes</h1></div>
                                            {/* <div>{qtServicos} Cadastrados</div> */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <h2 className="text-center">Perfil</h2>
                                    {/* Botão "Perfil" */}
                                    <Row className="mt-4 text-center">
                                        <Col>
                                        <Button variant="primary" className="btn-lg"
                                            onClick={togglePerfil}
                                        >
                                            <div><h1>Meus Dados</h1></div>
                                        </Button>
                                        </Col>
                                    </Row>



                                    {/* Status da Agenda */}
                                    {/* <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Status da Agenda</h4>
                                        <Button
                                            variant={agendaFechada === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            onClick={toggleAgendaStatus}
                                        >
                                            Aberta
                                        </Button>
                                        <Button
                                            variant={agendaFechada === 1 ? 'success' : 'secondary'}
                                            onClick={toggleAgendaStatus}
                                        >
                                            Fechada
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr /> */}

                                    {/* Tipo de Agenda
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Tipo de Agenda</h4>
                                        <Button
                                            variant={tipoAgenda === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            onClick={toggleTipoAgenda}
                                        >
                                            Global
                                        </Button>
                                        <Button
                                            variant={tipoAgenda === 1 ? 'success' : 'secondary'}
                                            onClick={toggleTipoAgenda}
                                        >
                                            Individual
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr /> */}

                                    {/* Tipo de Atendimento */}
                                    {/* <Row className="mt-3 text-center">
                                        <Col>
                                            <h4>Tipo de Atendimento</h4>
                                            <Button
                                                variant={tipoAtendimento === 1 ? 'success' : 'secondary'}
                                                // variant='success'
                                                className="me-2"
                                                onClick={toggleTipoAtendimento}
                                            >
                                                {tipoAtendimento === 0 ? 'Sem Colaborador' : 'Com Colaborador(es)'}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <hr />                                     */}

                                    {/* Botão "Serviços a Oferecer" */}
                                    {/* <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className="btn-lg"
                                            onClick={toggleServicos}
                                        >
                                            
                                            <div><h1>Serviços a Oferecer</h1></div>
                                            <div>{qtServicos} Cadastrados</div>
                                        </Button>
                                        </Col>
                                    </Row> */}
                                    
                                    {/* Botão "Agendar Serviço Avulso" */}
                                    {/* <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg"
                                            onClick={toggleAgendaAvulso}
                                        >
                                            <div><h1>Agendar Serviço Avulso</h1></div>
                                            <div>{qtServicosAvulsos} Serviços disponíveis</div>
                                        </Button>
                                        </Col>
                                    </Row> */}

                                    {/* Botão "Agendamentos"
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg">
                                            <div><h1>Agendamentos</h1></div>
                                            <div>xx Cadastrados</div> {/* Esse valor xx será atualizado dinamicamente depois //}
                                        </Button>
                                        </Col>
                                    </Row> */}
                                    
                                </Container>          
                                <div className="row">
                                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PCHome;